module.exports = __webpack_public_path__ + "img/details-company.png?1634fd69ba4595ee0d5f782f857293ef";